import { SessionSignInResult } from '@indigohive/cogfy-types/endpoints/signIn'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import * as yup from 'yup'
import { Button, CogfyLogo, OneTimePasswordInput } from '../../components'
import { useAuthentication, useCogfy, useToasts } from '../../hooks'

export function VerifyEmailPage () {
  const cogfy = useCogfy()
  const authentication = useAuthentication()
  const toasts = useToasts()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const token = location.state?.token || searchParams.get('token')
  const code = searchParams.get('code')

  const formik = useFormik({
    initialValues: {
      code: code || ''
    },
    validationSchema: yup.object().shape({
      code: yup.string().length(6).required()
    }),
    onSubmit: async ({ code }) => {
      try {
        const result = await cogfy.verifySignUp({ code }, { headers: { 'cogfy-sign-up-form': token } })

        // Set authenticated user
        const authenticatedUser: SessionSignInResult = {
          type: 'session',
          session: {
            sessionId: result.session.sessionId
          },
          id: result.id,
          name: result.name,
          email: result.email
        }
        authentication.onAuthenticatedUserChange?.(authenticatedUser)

        // Navigate to set password page
        navigate('/create-profile')
      } catch (error) {
        toasts.error('Error validating code')
      }
    }
  })

  return (
    <div className="w-full flex flex-col items-center">
      <div className="navbar max-w-screen-xl">
        <CogfyLogo size={48} />
      </div>

      {token && (
        <>
          <div className="w-96 p-6 mt-[8vh] mb-[16vh]">
            <div className="w-96 p-6 mt-[8vh] mb-[16vh]">
              <form onSubmit={formik.handleSubmit}>
                <h1 className="text-2xl font-semibold mb-2">
                  {t('VerifyEmail:Verify your email')}
                </h1>

                <p className="text-xl font-semibold text-gray-400 mb-8">
                  {t('Set the code received in email')}
                </p>

                <div className="my-2">
                  <OneTimePasswordInput
                    value={formik.values.code}
                    onChange={value => { formik.setFieldValue('code', value) }}
                  />
                </div>

                <Button
                  type="submit"
                  color="primary"
                  className="w-full mt-4"
                  disabled={formik.isSubmitting}
                >
                  {t('Verify')}
                </Button>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
